/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Dashboard 2 React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Dashboard 2 React using thie file.
 */

const colors = {
  background: {
    default: "#F3F5F7",
    paper: "#FFFFFF",
  },

  text: {
    main: "#5F6B7A",
    primary: "#172033",
    secondary: "#5F6B7A",
    focus: "#172033",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#3157C8",
    focus: "#2445A8",
  },

  secondary: {
    main: "#5F6B7A",
    focus: "#172033",
  },

  accent: {
    main: "#D9602B",
    focus: "#B84E22",
  },

  info: {
    main: "#3157C8",
    focus: "#2445A8",
  },

  success: {
    main: "#177A65",
    focus: "#126653",
  },

  warning: {
    main: "#A15C07",
    focus: "#7E4705",
  },

  error: {
    main: "#C63D4B",
    focus: "#A52F3B",
  },

  light: {
    main: "#F8FAFC",
    focus: "#EEF2F6",
  },

  dark: {
    main: "#172033",
    focus: "#101828",
  },

  grey: {
    100: "#F8FAFC",
    200: "#F3F5F7",
    300: "#D8DEE8",
    400: "#AEB8C7",
    500: "#8490A1",
    600: "#5F6B7A",
    700: "#3D4757",
    800: "#172033",
    900: "#101828",
  },

  gradients: {
    primary: {
      main: "#3157C8",
      state: "#2445A8",
    },

    secondary: {
      main: "#747b8a",
      state: "#495361",
    },

    info: {
      main: "#3157C8",
      state: "#2445A8",
    },

    success: {
      main: "#177A65",
      state: "#126653",
    },

    warning: {
      main: "#A15C07",
      state: "#7E4705",
    },

    error: {
      main: "#C63D4B",
      state: "#A52F3B",
    },

    light: {
      main: "#F8FAFC",
      state: "#D8DEE8",
    },

    dark: {
      main: "#172033",
      state: "#101828",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#DCE6FF",
      text: "#2445A8",
    },

    secondary: {
      background: "#d7d9e1",
      text: "#6c757d",
    },

    info: {
      background: "#aecef7",
      text: "#095bc6",
    },

    success: {
      background: "#D8F2EA",
      text: "#126653",
    },

    warning: {
      background: "#F8E6C6",
      text: "#7E4705",
    },

    error: {
      background: "#F7DADF",
      text: "#A52F3B",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  coloredShadows: {
    primary: "#3157C8",
    secondary: "#110e0e",
    info: "#3157C8",
    success: "#177A65",
    warning: "#A15C07",
    error: "#C63D4B",
    light: "#D8DEE8",
    dark: "#172033",
  },

  inputBorderColor: "#D8DEE8",
  divider: "#D8DEE8",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
